'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.countryListWidget = function ({countryListModel}) {
	if (!countryListModel) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		let currentList, currentPreferred;
		const widget = this,
			dataList = widget.find('datalist'),
			input = widget.find('input');
		countryListModel.addEventListener('countriesLoaded', ({list, preferred}) => {
			dataList.empty();
			currentList = list;
			currentPreferred = Object.keys(list).find(countryName => list[countryName] === preferred) || '';
			Object.keys(list).forEach(countryName => {
				const option = mmWidgets('<option>').attr({value: countryName});
				option.appendTo(dataList);
			});
			input.val(currentPreferred);
		});
		input.on('focus', () => input.val(''));
		input.on('blur', () => {
			const currentName = input.val()?.toUpperCase();
			if (!currentName || !currentList[currentName]) {
				input.val(currentPreferred);
			}
		});

	});
};



